'use client';

import { useInject } from '@actr/di/src/hook/use-inject';
import { Button, ButtonSizes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { Modal } from '@actr/ui/src/components/_modals/modal';
import { observer } from 'mobx-react-lite';
import React from 'react';

import config from '@/configs';
import LocalAuthStore from '@/store/auth';

import * as Styled from '../style.css';

export type UnauthorizedModalProps = {
    isShowModal: boolean;
    onClose: () => void;
    isMobile: boolean;
}

const UnauthorizedModal: React.FC<UnauthorizedModalProps> = ({
  isShowModal,
  onClose,
  isMobile
}) => {
  const auth = useInject(LocalAuthStore);

  function handleAuthClick() {
    auth.toggleOpenLoginForm(true);
    onClose();
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 300);
  }

  return (
    <Modal
      className={Styled.Modal({ isUnauthModal: true })}
      Title="Добавление отзыва"
      isPopup={!isMobile}
      open={isShowModal}
      onClose={onClose}
      hideFooter={true}>
      <div className={Styled.ModalWrapper}>
        <img className={Styled.AuthImg} src={`${config.cmsMediaUrl}images/seo/auth.png`} alt="auth img" />
        <div className={Styled.MainUnauthContentWrapp}>
          <Text className={Styled.ModalText} font="title.xl">
            Авторизация пользователя
          </Text>
          <Text className={Styled.ModalText} font="paragraph.m">
            Чтобы оставить отзыв, необходимо войти на сайт или зарегистрироваться
          </Text>
        </div>
        <Button
          className={Styled.AuthButton}
          size={ButtonSizes.M}
          onClick={handleAuthClick}>
          Войти
        </Button>
      </div>
    </Modal>
  );
};

export default observer(UnauthorizedModal);
